import { Grid } from '@mui/material';
import { Section } from '.';
import { useTranslation } from 'react-i18next';
import { PhilipsGray } from '../../style/StyleHelpers';
import { isFeatureVisible } from '../services/ClaimsHelper';
import { AppStore } from '../store';
import type { ISectionLayoutProps } from '../../types';

export const gridLayout = {
  xs: {
    input: 7,
    infoIcon: 2,
    optional: 6,
    price: 6,
    qty: 3,
  },
  sm: {
    input: 4,
    infoIcon: 1,
    optional: 2,
    price: 2,
    qty: 3,
  },
  fullWidth: 12,
};

/**
 * Creates and Renders the grid layout required for placing various input controls
 * @param {ISectionProps} props the properties for the section component
 * @returns {JSX.Element} the section component
 */
export const SectionLayout = ({
  onChange,
  section,
  onOptionalChange,
  isDefaultFlow,
}: ISectionLayoutProps) => {
  const { t } = useTranslation();

  const featureFlags = AppStore.getState().claimsData?.featureFlags;

  const optionalCheck = isFeatureVisible(featureFlags?.Optional);
  const listPriceCheck = isFeatureVisible(featureFlags?.ListPrice);
  const showAsterisk = isDefaultFlow ? '' : ' *';
  return (
    <Grid container columns={gridLayout.fullWidth} sx={{ width: '100%', height: '100%' }}>
      <Grid
        container
        sx={{
          display: {
            xs: 'none',
            sm: 'flex',
          },
          background: PhilipsGray,
          alignContent: 'center',
          height: 'fit-content',
        }}
        className="sectionLayout"
        size={{
          sm: gridLayout.fullWidth,
        }}
      >
        <Grid
          size={{
            sm: gridLayout.sm.input,
          }}
        />

        <Grid
          size={{
            sm: gridLayout.sm.infoIcon,
          }}
        />

        <Grid
          size={{
            sm: gridLayout.sm.qty,
          }}
        >
          <h6 className="sectionLayoutHeader">Qty</h6>
        </Grid>

        <Grid
          size={{
            sm: gridLayout.sm.optional,
          }}
        >
          {optionalCheck ? <h6 className="sectionLayoutHeader">{t('labels.optional')}</h6> : null}
        </Grid>

        <Grid
          size={{
            sm: gridLayout.sm.price,
          }}
        >
          {listPriceCheck ? (
            <h6 className="sectionLayoutHeader priceHeader text-right">
              {`${t('labels.listPrice')}${showAsterisk}`}
            </h6>
          ) : null}
        </Grid>
      </Grid>
      <Grid
        container
        sx={{
          width: '100%',
          height: { xs: '100%', sm: '90%' },
          overflow: 'auto',
        }}
        size={gridLayout.fullWidth}
      >
        <Section section={section} onChange={onChange} onOptionalChange={onOptionalChange} />
      </Grid>
    </Grid>
  );
};
